import { GLOBAL_NAME } from '../constants/Globals';
export default function shouldSendReadyState(nextReadyState) {
  const lastSentReadyState = window[GLOBAL_NAME].lastSentReadyState;
  if (lastSentReadyState && lastSentReadyState.objectId === nextReadyState.objectId && lastSentReadyState.objectTypeId === nextReadyState.objectTypeId) {
    return false;
  }
  return true;
}